import React from "react"
import { Main } from "./style"

const GridIcon = ({ changeView, displayType }) => {
  return (
    <Main onClick={() => changeView("grid")} displayType={displayType}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </Main>
  )
}

export default GridIcon
